import React from "react";
import Pricetemplatesecond from "./pricesecondtemplate";
import Pricetemplatefirst from "./pricefirsttemplate";
const price = () => {
  return (
    <div>
      <Pricetemplatefirst />
      <Pricetemplatesecond />
    </div>
  );
};

export default price;
